import { render, staticRenderFns } from "./ReceiptRec.vue?vue&type=template&id=7737b4f1&scoped=true&"
import script from "./ReceiptRec.vue?vue&type=script&lang=js&"
export * from "./ReceiptRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7737b4f1",
  null
  
)

export default component.exports